import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Ticket(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_91_7)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13.65.293a1 1 0 011.39-.024l2.138 1.996.004.004.017.016a.997.997 0 01.014 1.416c-.845.86-.84 2.272-.012 3.086.86.844 2.27.84 3.084.014l.006-.006a.997.997 0 011.445.028l1.995 2.138a1 1 0 01-.024 1.389L10.35 23.707a1 1 0 01-1.39.024L6.827 21.74a1.143 1.143 0 01-.142-.16 1 1 0 01.112-1.29c.832-.825.835-2.237-.006-3.085-.799-.805-2.099-.863-2.938-.18a1 1 0 01-1.583.159l-2-2.144a1 1 0 01.024-1.389L13.65.293zM3.085 15.126c1.62-.959 3.765-.702 5.125.67a4.23 4.23 0 01.635 5.091l.774.723 11.99-11.991-.72-.772c-1.602.95-3.725.708-5.09-.634-1.393-1.369-1.574-3.494-.638-5.095l-.78-.728-11.99 11.991.694.745zm7.265-4.619a1 1 0 010 1.414l-1.571 1.572a1 1 0 01-1.415-1.414l1.572-1.572a1 1 0 011.414 0zm6.286 0a1 1 0 010 1.414l-4.715 4.715a1 1 0 01-1.414-1.414l4.715-4.715a1 1 0 011.414 0z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_91_7"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Ticket;